import React from "react";
import Typography from '@mui/material/Typography';
import { ReactComponent as Icon1 } from './clock.svg';
import { ReactComponent as Icon2 } from './chat.svg';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MailIcon from '@mui/icons-material/Mail';
import './ContactDetails.scss';

const ContactDetails = () => {
    return (
        <div className="contact-details">

            <div className="contact-description text-center">
                <div className="icons">
                    <Icon1 />
                    <Icon2 />
                </div>

                <Typography variant="h5" gutterBottom component="div" className="">
                    Contacting Me
                </Typography>

                <Typography variant="body2" gutterBottom >
                    Feel free to talk to me about anything that bothers you. If you need a helping hand, 
                    please don't hesitate to contact me.
                </Typography>
            </div>

            <div className="contact-info">
                <div>
                    <div className="contact-icon">
                        <LocationOnIcon />
                    </div>

                    <div className="contact-info-data">
                        <Typography variant="h6" gutterBottom component="div" className="">
                            ADDRESS:
                        </Typography>
                        <Typography variant="subtitle1" gutterBottom component="div" className="">
                            Rishikesh - Uttarakhand - India
                        </Typography>
                    </div>
                </div>

                <div>
                    <div className="contact-icon">
                        <MailIcon />
                    </div>

                    <div className="contact-info-data">
                        <Typography variant="h6" gutterBottom component="div" className="">
                            EMAIL:
                        </Typography>
                        <Typography variant="subtitle1" gutterBottom component="div" className="">
                            anshikaagrawal5501@gmail.com
                        </Typography>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContactDetails;